import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { RecentValidation } from "../types";

const MAX_ENTRIES = 10;

/** Stable ID for a validation — same inputs produce the same ID so re-running
 *  updates the existing entry rather than creating a duplicate. */
export function makeRecentId(
  hindcast: string,
  layer: string,
  lon: number,
  lat: number,
  radius: number
): string {
  return `${hindcast}|${layer}|${lon.toFixed(4)}|${lat.toFixed(4)}|${radius}`;
}

interface RecentStore {
  entries: RecentValidation[];
  addEntry: (entry: RecentValidation) => void;
  removeEntry: (id: string) => void;
  clearAll: () => void;
}

export const useRecentStore = create<RecentStore>()(
  persist(
    (set) => ({
      entries: [],

      addEntry: (entry) =>
        set((s) => {
          // Replace existing entry with same id, or prepend; cap at MAX_ENTRIES.
          const without = s.entries.filter((e) => e.id !== entry.id);
          return { entries: [entry, ...without].slice(0, MAX_ENTRIES) };
        }),

      removeEntry: (id) =>
        set((s) => ({ entries: s.entries.filter((e) => e.id !== id) })),

      clearAll: () => set({ entries: [] }),
    }),
    { name: "hindcast-recent-validations" }
  )
);
